/**
 * Switch between development and production APIs for this module
 * by swapping comments on the corresponding lines.
 */

// import profileApi from './dev'; // dev
import profileApi from './prod'; // prod

export default profileApi;
